import { useSelector } from 'react-redux'
import { getRooms } from '../reducers/bookingCalendar/selectors/erhaltenZimmer'

function useFindRoomById() {
  const rooms = useSelector(getRooms)

  return function(id: string, deleted: boolean = true) {
    return rooms.find(
      r => String(r.id) === String(id) && (deleted || r.isDeleted === deleted),
    )
  }
}

export default useFindRoomById
